import { useTranslation } from "react-i18next";
import { useOpenSession } from "@src/api/useOpenSession";
import identificationStart from "@src/assets/identification_start.svg";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import useZustandStore from "@src/helpers/zustand";

function StartIdentification() {
  const { t } = useTranslation();
  const openSessionMutation = useOpenSession();
  const { data: globalState } = useZustandStore((state) => state);

  return (
    <Container>
      <div className="py-6">
        <TitleAndDesc desc={t("startIdentification.desc")} title={t("startIdentification.title")} />
      </div>

      <div className="w-full py-6">
        <img
          alt="placeholder"
          className="h-auto max-h-[30vh] w-full bg-contain"
          src={identificationStart}
        />
      </div>
      <div
        className="w-full self-end rounded-[6px] bg-white py-8
       max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
        onClick={() => {
          openSessionMutation.mutate(globalState.apiKey);
        }}
      >
        <Button className="w-full">{t("startIdentification.next")}</Button>
      </div>
    </Container>
  );
}

export default StartIdentification;
